import ServiceGraphQL from 'src/service/gql-service';
import { updateMicrosite } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const UpdateMicrosite = (lat, lng) => {
  const params = {
    query: updateMicrosite.QUERY,
    variables: {
      lat: lat.toString(),
      lng: lng.toString()
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.updateMicrosite;
    })
    .catch((err) => {
      throw err;
    });
};
